import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function RequireAdmin({ children }) {
    const { user, ready } = useAuth();
    if (!ready) return null;
    if (!user) return <Navigate to="/auth" replace />;
    if (user.role === "club_admin" || user.role === "super_admin") return children;
    return <Navigate to="/" replace />;
}
